import { CustomSelector, ECustomSelector } from '@globalmed/atlas-ui';
import { useTranslation } from 'react-i18next';
import styles from './NavPanelInstitutionSelector.module.css';
import { useInstitutionOptions } from '@/hooks/useInstitutionOptions';

/**
 * Institution switcher shown in the navigation panel for regular users.
 * Lets the current user pick which institution to act within; disabled
 * when only one institution is available.
 * @returns The institution switcher, or null when the user has no
 * institutions available.
 */
export const NavPanelInstitutionSelector = () => {
  const { t } = useTranslation();
  const { currentInstitution, institutionOptions, onInstitutionChange } =
    useInstitutionOptions();

  if (!institutionOptions.length) return null;

  return (
    <div className={styles.wrapper}>
      <CustomSelector
        sx={{ width: '100%' }}
        type={ECustomSelector.Select}
        options={institutionOptions}
        selected={currentInstitution?.id}
        onChange={onInstitutionChange}
        disabled={institutionOptions.length === 1}
        aria-label={t('common.select-institution')}
      />
    </div>
  );
};
